import React from 'react';
import { Link } from 'react-router-dom';
import { lnAssets } from '../utils/lnAssets';
import {
  SITE_BRAND_SEAL_BOTTOM_ARC,
  SITE_BRAND_SEAL_TOP_ARC,
  SITE_FULL_NAME,
} from '../sitePlaceholders';
import '../styles/I3NavBrand.css';

/** Header logo + wordmark (public/lisa/TheBridgeLogo.png) */
const I3NavBrand: React.FC = () => (
  <Link to="/" className="i3-nav-brand" aria-label={SITE_FULL_NAME}>
    <img
      src={lnAssets.logos.emblemLegacy}
      alt=""
      className="i3-nav-brand-logo"
      decoding="async"
      aria-hidden
    />
    <span className="i3-nav-brand-text">
      <span className="i3-nav-brand-name">{SITE_BRAND_SEAL_TOP_ARC}</span>
      <span className="i3-nav-brand-sub">{SITE_BRAND_SEAL_BOTTOM_ARC}</span>
    </span>
  </Link>
);

export default I3NavBrand;
